import {FaPlay, FaPause} from "react-icons/fa";
import {useAudioPlayer} from "../Hooks/useAudioPlayer";

export const RecordingPlayer = ({url}) => {
  // Assuming your hook provides 'seek', 'duration', and 'currentTime'
  const {isPlaying, progress, togglePlay, displayTime, seek} =
    useAudioPlayer(url);

  if (!url)
    return <span className="text-gray-400 text-xs italic">No Recording</span>;

  const handleSeek = (e) => {
    const newProgress = parseFloat(e.target.value);
    seek(newProgress); // Passes the percentage (0-100) to the hook
  };

  return (
    <div className="flex items-center space-x-2 w-full max-w-xs bg-gray-50 p-2 rounded-lg border border-gray-200">
      {/* Play/Pause Button - Styled to match previous versions */}
      <button onClick={togglePlay} className="p-1 text-[#2ba9cd]">
        {isPlaying ? <FaPause /> : <FaPlay />}
      </button>

      {/* Progress Slider - Styled to match previous versions */}
      <div className="flex-1 flex items-center">
        <input
          type="range"
          min="0"
          max="100"
          value={progress || 0}
          onChange={handleSeek}
          className="w-full h-2 bg-gray-300 rounded-full appearance-none cursor-pointer accent-[#2ba9cd]"
          style={{
            background: `linear-gradient(to right, #2ba9cd ${progress}%, #d1d5db ${progress}%)`,
          }}
        />
      </div>

      {/* Time Display - Styled to match previous versions */}
      <span className="text-xs text-gray-600 font-mono whitespace-nowrap">
        {displayTime}
      </span>
    </div>
  );
};
